import React from "react";
import { Helmet } from "react-helmet";

// Site-wide SEO defaults. Used whenever a page does not pass its own value,
// so existing pages that only set `title` still get sensible meta tags.
const SITE_NAME = "EFH - Education From Home";
const SITE_URL = "https://efhonline.com";
const DEFAULT_DESCRIPTION =
  "EFH (Education From Home) offers online Computer Science courses and tuition for ICSE and CBSE students of Class 9-12, taught by expert mentors. Learn at your own pace, anytime and anywhere.";
const DEFAULT_KEYWORDS =
  "EFH, Education From Home, online courses, online tuition, ICSE, CBSE, Computer Science, Class 9-12, e-learning, online certification";
const DEFAULT_IMAGE = SITE_URL + "/logo.png";

function Title(props) {
  const options = props.options || {};

  const title = options.title ? options.title : SITE_NAME;
  const description = options.description ? options.description : DEFAULT_DESCRIPTION;
  const keywords = options.keywords ? options.keywords : DEFAULT_KEYWORDS;
  const image = options.image ? options.image : DEFAULT_IMAGE;

  // Canonical / og:url: always the chosen host (non-www) + current path, so
  // www/non-www and ?source=... variants all consolidate to one canonical URL.
  const path =
    typeof window !== "undefined" ? window.location.pathname : "/";
  const canonical = options.url ? options.url : SITE_URL + path;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={SITE_NAME} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonical} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default Title;
